<template>
  <div class="list-logos u-pad-y-xl u-pad-y-md--sm">  
    <p v-if="data.titre" class="u-uppercase t-h3 u-marg-x-1of12 u-x10of12">{{data.titre}}</p>
    <div class="u-row u-evenly u-marg-t-lg">
      <div
        v-for="(logo, index) in data.logos" :key="logo.name"
        class="u-w1of12 u-w3of12--sm u-bg-white u-marg-sm u-round u-overflow-hidden u-box-1by1"
      >
        <a :href="data.urls[index].url" target="_blank" v-if="data.urls && data.urls[index] && data.urls[index].url" class="list-logos__logo u-block u-wrapper-panel">
          <app-image :id="logo.id" :src="logo.url" class="u-fit-contain" alt="Partenaire picture"/>
        </a>
        <div v-else class="list-logos__logo u-wrapper-panel">
          <app-image :id="logo.id" :src="logo.url" class="u-fit-contain" alt="Partenaire picture"/>
        </div>
      </div>        
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
  },

  data() {
    return {
      size: 0,
    }
  }
}
</script>

<style lang="stylus">
.list-logos
  &__logo
    padding 20%
    .c-img
      object-fit contain
</style>